import axios from '../../../configs/axios';

export const registerPressUser = (data, token) =>
  axios.post('/press/register.json', data, {
    params: { token },
  });

export const requestPressRenewal = data => axios.post('/press/renewal_request.json', data);
